import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  button: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-8'],
    padding: '8px 20px 8px 12px',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    backgroundColor: colors.primaryBackground,
    border: `1px solid ${colors.primaryBorder}`,
    borderRadius: anatomy.borderRadiusS,
    cursor: 'pointer',
    outline: 'none',
    ':hover': {
      color: colors.accentText,
    },
  },
  text: {
    margin: 0,
  },
});
